import { CustomButton, SearchBar, SwitchButton } from "components/form";
import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CustomModal, PopupModal } from "components/modals/ModalBox";
import "./UserManagement.scss";
import useDebounce from "common/UseDebounce";
import { toastMessage } from "utils/toastMessage";
import NotFound from "common/NotFound";
import useButtonLoader from "common/UseButtonLoader";
import { searchDateFormat } from "common/InputForm";
import { FaRegEye, FaRegTrashAlt } from "react-icons/fa";
import { toast } from "sonner";
import Pagination from "react-js-pagination";
import { DatePicker } from "common/InputForm";
import { userPlaceholder } from "assets/icons";
import {
  userListApis,
  userRemoveApi,
  userStatusChangeApi,
} from "services/user";
import useFullPageLoader from "common/UseFullPageLoader";
import { dateFormat } from "utils/dateFormat";
import Select from "react-select";
import axios from "axios";
import { setJwtToken } from "config/axiosInstance";
const UserManagement = () => {
  const [deleteModal, setDeleteModal] = useState(false);
  const [loader, onShow, onHide] = useFullPageLoader();
  const [userList, setUserList] = useState([]);
  const [search, setSearch] = useState("");
  const [searchParams, setSearchParams] = useSearchParams();
  const debouncedValue = useDebounce(search, 300);
  const [fieldName, setFieldName] = useState("");
  const [direaction, setDirection] = useState("");
  const [selected, setSelected] = useState({});
  const [statusModal, setStatusModal] = useState(false);
  const [total, setTotal] = useState(null);
  const [buttonLoader, setButtonLoader] = useButtonLoader("Yes");
  const [buttonLoaders, setButtonLoaders] = useButtonLoader("Yes");
  const activePage = +searchParams.get("page") || 1;
  let searchStartDate = searchParams.get("startDate") || "";
  let searchEndDate = searchParams.get("endDate") || "";
  const limit = +searchParams.get("limit") || 10;
  const statusValue = searchParams.get("status") || "";
  const planValue = searchParams.get("plan") || "";
  const bodyShapeValue = searchParams.get("bodyShape") || "";
  const styleIdentityValue = searchParams.get("styleIdentity") || "";
  const [flauntPartsValue, setFlauntPartsValue] = useState([]);
  const [flauntparts, setFlauntParts] = useState([]);
  const [downplayPartsValue, setDownplayPartsValue] = useState([]);
  const [downPlayParts, setDownplayParts] = useState([]);
  const [imagePreview, setImagePreview] = useState(false);
  const [imageUrl, setImageUrl] = useState("");
  const [buttonLoaderFile, setButtonLoaderFile] = useButtonLoader("Export");
  // sort
  const toggleSortOrder = () => {
    setDirection(direaction === "ASC" ? "DESC" : "ASC");
  };
  const handleSort = (field) => {
    if (field === fieldName) {
      toggleSortOrder();
    } else {
      setFieldName(field);
      setDirection("ASC");
    }
  };
  // delete handler
  const deleteHandler = (id) => {
    setSelected({ id });
    setDeleteModal(true);
  };
  // change delete handler
  const changeDeleteHandler = async () => {
    try {
      setButtonLoaders(true);
      const res = await userRemoveApi(selected.id);
      if (res.data.status === 200) {
        toastMessage(res.data.message, "success", "delete");
        setDeleteModal(false);
        userListHandler();
      } else {
        toastMessage(res.data.message, "error", "delete");
      }
    } catch (e) {
      console.log("error:", e.error);
    } finally {
      setButtonLoaders(false);
    }
  };
  // change student status
  const statusHandler = (teacherId, status) => {
    setSelected({
      ...selected,
      userId: teacherId,
      status: status === "true" ? "false" : "true",
    });
    setStatusModal(true);
  };
  /**************Change Status Handler*********************/
  const changeStatusHandler = async () => {
    try {
      setButtonLoader(true);
      const res = await userStatusChangeApi(selected);
      if (res.data.status === 200) {
        toastMessage(res.data.message, "success", "changeStatus");
        setStatusModal(false);
        userListHandler();
      } else {
        toastMessage(res.data.message, "error", "changeStatus");
      }
    } catch (e) {
      console.log("error:", e.error);
    } finally {
      setButtonLoader(false);
    }
  };
  // //*********start Date search********* */
  const handleStartDate = (date) => {
    searchParams.set("page", 1);
    searchParams.set("startDate", searchDateFormat(date));
    setSearchParams(searchParams);
  };
  // //*********end Date search********* */
  const handleEndDate = (date) => {
    searchParams.set("page", 1);
    searchParams.set("endDate", searchDateFormat(date));
    setSearchParams(searchParams);
  };
  /*************Reset Filter Handler*********************/
  const resetFilterHandler = () => {
    searchParams.delete("status");
    searchParams.delete("page");
    searchParams.delete("startDate");
    searchParams.delete("endDate");
    searchParams.delete("plan");
    searchParams.delete("bodyShape");
    searchParams.delete("styleIdentity");
    setDownplayPartsValue([]);
    setDownplayParts([]);
    setFlauntParts([]);
    setFlauntPartsValue([]);
    setSearch("");
    setSearchParams(searchParams);
  };
  //*********Handel Pagination********* */
  const handlePageChange = (event) => {
    searchParams.set("page", event);
    setSearchParams(searchParams);
  };
  /**************Modal CLose*********************/
  const closeModal = () => {
    setStatusModal(false);
    setSelected({});
  };
  //-----------status-------------
  const handleStatus = (event) => {
    const value = event.target.value;
    searchParams.set("status", value);
    searchParams.set("page", 1);
    setSearchParams(searchParams);
  };
  const handlePlanStatus = (event) => {
    const value = event.target.value;
    searchParams.set("plan", value);
    searchParams.set("page", 1);
    setSearchParams(searchParams);
  };
  const handleBodyShap = (event) => {
    const value = event.target.value;
    searchParams.set("bodyShape", value);
    searchParams.set("page", 1);
    setSearchParams(searchParams);
  };
  const handleStyle = (event) => {
    const value = event.target.value;
    searchParams.set("styleIdentity", value);
    searchParams.set("page", 1);
    setSearchParams(searchParams);
  };

  const handleflauntParts = (selectedOptions) => {
    // Extract the values from the selected options
    setFlauntPartsValue(selectedOptions);
    const valuesArray = selectedOptions.map((option) => option.value);
    // Set the state with the array of values
    setFlauntParts(valuesArray);
    searchParams.set("page", 1);
    setSearchParams(searchParams);
  };
  const handledownplayParts = (selectedOptions) => {
    // Extract the values from the selected options
    setDownplayPartsValue(selectedOptions);
    const valuesArray = selectedOptions.map((option) => option.value);
    // Set the state with the array of values
    setDownplayParts(valuesArray);
    searchParams.set("page", 1);
    setSearchParams(searchParams);
  };

  const downplayArray = [
    { value: "Neckline", label: "Neckline" },
    { value: "Waist", label: "Waist" },
    { value: "Legs", label: "Legs" },
    { value: "Arms", label: "Arms" },
    { value: "Back", label: "Back" },
    { value: "Buttocks", label: "Buttocks" },
  ];
  // user list handler
  const userListHandler = async (
    page = activePage,
    limit = "10",
    search = debouncedValue,
    sortField = fieldName || "createdAt",
    sortDirection = direaction,
    startDate = searchStartDate,
    endDate = searchEndDate,
    status = statusValue,
    plan = planValue,
    bodyShape = bodyShapeValue,
    styleIdentity = styleIdentityValue,
    flauntParts = flauntparts,
    downplayParts = downPlayParts
  ) => {
    try {
      onShow();
      const res = await userListApis({
        page,
        search,
        limit,
        sortField,
        sortDirection,
        startDate,
        endDate,
        status,
        plan,
        bodyShape,
        styleIdentity,
        flauntParts,
        downplayParts,
      });
      if (res?.data?.status === 200) {
        setTotal(res?.data?.data?.total);
        setUserList(res.data?.data?.users);
        onHide();
      } else {
        toastMessage(res?.data?.message, "error", "userList");
      }
    } catch (e) {
      onHide();
      toast.error(e.message);
    }
  };
  useEffect(() => {
    if (Number(activePage) === 1) {
      searchParams.delete("page");
      setSearchParams(searchParams);
    }
    userListHandler();
  }, [
    searchParams,
    debouncedValue,
    fieldName,
    direaction,
    searchStartDate,
    searchEndDate,
    statusValue,
    planValue,
    bodyShapeValue,
    styleIdentityValue,
    flauntparts,
    downPlayParts,
  ]);
  useEffect(() => {
    if (search) {
      searchParams.delete("page");
    }
  }, []);
  const url = `${process.env.REACT_APP_API_URL}/export/user`;
  const downloadFile = async (
    url,
    fileName,
    params = {
      userType: "student",
      startDate: searchStartDate,
      endDate: searchEndDate,
      status: statusValue,
      plan: planValue,
      bodyShape: bodyShapeValue,
      styleIdentity: styleIdentityValue,
      flauntParts: flauntparts,
      downplayParts: downPlayParts,
    }
  ) => {
    try {
      setButtonLoaderFile(true);
      const { headers } = setJwtToken();
      const response = await axios.get(url, {
        params,
        responseType: "blob",
        headers,
      });
      if (response.status === 200) {
        const blob = new Blob([response.data], {
          type: response.headers["content-type"],
        });
        const blobUrl = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = blobUrl;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);
      } else {
        throw new Error("File download failed");
      }
    } catch (error) {
      console.error("Error downloading file:", error);
      if (axios.isCancel(error)) {
        console.log("Request cancelled:", error.message);
      } else {
        console.error("Error:", error.message);
      }
    } finally {
      setButtonLoaderFile(false);
    }
  };
  return (
    <>
      <div className="student_management">
        <div className="card top_card">
          <div className="dashboard_title has_child">
            <h3> User Management</h3>
            <div className="d-flex"></div>
          </div>
          <div className="button_section_wrap">
            <div className="search_wrapper">
              <SearchBar
                placeholder={"Search..."}
                onChange={(e) => {
                  setSearch(e.target.value);
                  searchParams.delete("page");
                  setSearchParams(searchParams);
                }}
                value={search}
              />
              <div className="d-flex">
                <select
                  className="input form-control"
                  value={statusValue}
                  onChange={handleStatus}
                >
                  <option value={""}>Select Status</option>
                  <option value="true">Active</option>
                  <option value="false">In Active</option>
                </select>
                <select
                  className="input form-control"
                  value={planValue}
                  onChange={handlePlanStatus}
                >
                  <option value={""}> Select Plan Status</option>
                  <option value="free">Free</option>
                  <option value="advance">Premium</option>
                </select>
                <DatePicker
                  className="form-control "
                  name="startDate"
                  selected={searchStartDate}
                  placeholder="Start Date"
                  onChange={(date) => handleStartDate(date)}
                  maxDate={searchEndDate}
                />
                <DatePicker
                  name="endDate"
                  className="form-control"
                  placeholder="End Date"
                  selected={searchEndDate}
                  onChange={(date) => handleEndDate(date)}
                  minDate={searchStartDate}
                />
              </div>
            </div>
            <div className="button_section">
              <div className="d-flex">
                <select
                  className="input form-control"
                  value={bodyShapeValue}
                  onChange={handleBodyShap}
                >
                  <option value=""> Select Body Shape</option>
                  <option value="Round">Round</option>
                  <option value="Triangle">Triangle</option>
                  <option value="Hourglass">Hourglass</option>
                  <option value="Rectangle">Rectangle</option>
                  <option value="Inverted Triangle">Inverted Triangle</option>
                </select>
                <select
                  className="input form-control"
                  value={styleIdentityValue}
                  onChange={handleStyle}
                >
                  <option value="">Select Style Identity</option>
                  <option value="Bold Boss">Bold Boss</option>
                  <option value="Dreamy Diva">Dreamy Diva</option>
                  <option value="Timeless Queen">Timeless Queen</option>
                  <option value="Effortless Chic">Effortless Chic</option>
                </select>

                <Select
                  placeholder={<div>Select Flaunt Parts</div>}
                  name="select"
                  className="multi_select multi-select"
                  value={flauntPartsValue}
                  options={downplayArray}
                  isMulti
                  onChange={handleflauntParts}
                />

                <Select
                  placeholder={<div>Select Downplay Parts</div>}
                  name="select"
                  className="multi_select"
                  value={downplayPartsValue}
                  options={downplayArray}
                  isMulti
                  onChange={handledownplayParts}
                />
                <CustomButton
                  type="button"
                  className="button mx-2"
                  ref={buttonLoaderFile}
                  onClick={() => downloadFile(url, "User")}
                >
                  Export
                </CustomButton>
                <CustomButton onClick={resetFilterHandler}>Reset</CustomButton>
              </div>
            </div>
          </div>
        </div>
        <div className="card">
          <div className="card-body">
            <div className="table_wrap">
              <table className="table custom_table">
                <thead>
                  <tr>
                    <th className="nowrap">S.No.</th>

                    <th className="nowrap">Profile</th>
                    <th
                      className="nowrap cursor-pointer"
                      onClick={() => handleSort("name")}
                    >
                      Name
                      <span className="shorting">
                        {fieldName === "name"
                          ? direaction === "ASC"
                            ? "↑"
                            : "↓"
                          : "↓"}
                      </span>
                    </th>
                    <th className="nowrap">Date Of Birth </th>
                    <th
                      className="nowrap cursor-pointer"
                      onClick={() => handleSort("mobile")}
                    >
                      Mobile No
                      <span className="shorting">
                        {fieldName === "mobile"
                          ? direaction === "ASC"
                            ? "↑"
                            : "↓"
                          : "↓"}
                      </span>
                    </th>
                    <th
                      className="nowrap cursor-pointer"
                      onClick={() => handleSort("email")}
                    >
                      Email
                      <span className="shorting">
                        {fieldName === "email"
                          ? direaction === "ASC"
                            ? "↑"
                            : "↓"
                          : "↓"}
                      </span>
                    </th>
                    <th
                      className="nowrap cursor-pointer"
                      onClick={() => handleSort("bodyShape")}
                    >
                      Body Shape
                      <span className="shorting">
                        {fieldName === "bodyShape"
                          ? direaction === "ASC"
                            ? "↑"
                            : "↓"
                          : "↓"}
                      </span>
                    </th>
                    <th
                      className="nowrap cursor-pointer"
                      onClick={() => handleSort("styleIdentity")}
                    >
                      Style Identity
                      <span className="shorting">
                        {fieldName === "styleIdentity"
                          ? direaction === "ASC"
                            ? "↑"
                            : "↓"
                          : "↓"}
                      </span>
                    </th>
                    <th className="nowrap">Flaunt Parts</th>
                    <th className="nowrap">Downplay Parts</th>
                    <th
                      className="nowrap cursor-pointer"
                      onClick={() => handleSort("planName")}
                    >
                      Plan
                      <span className="shorting">
                        {fieldName === "planName"
                          ? direaction === "ASC"
                            ? "↑"
                            : "↓"
                          : "↓"}
                      </span>
                    </th>
                    <th className="nowrap text-center">Status</th>
                    <th className="nowrap text-center">View Referrals</th>
                    <th className="nowrap text-center">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {loader}
                  {userList && userList?.length > 0 ? (
                    userList?.map((data, index) => {
                      return (
                        <tr key={++index}>
                          {/* <td className="nowrap">{index + 1}</td> */}
                          <td className="nowrap">
                            {++index + (activePage - 1) * 10}
                          </td>
                          <td className="nowrap">
                            <button
                              type="button"
                              onClick={() => {
                                setImagePreview(true);
                                setImageUrl(data?.profile);
                              }}
                            >
                              <img
                                src={
                                  data?.profile
                                    ? data?.profile
                                    : userPlaceholder
                                }
                                className="avatar"
                                alt=""
                              />
                            </button>
                          </td>
                          <td className="nowrap">{data?.name}</td>
                          <td className="nowrap">{dateFormat(data?.dob)}</td>

                          <td className="nowrap">
                            {data?.countryCode + data?.mobile || "---"}
                          </td>

                          <td className="">{data?.email}</td>
                          <td>{data?.bodyShape}</td>
                          <td>{data?.styleIdentity}</td>

                          <td>
                            {" "}
                            {data?.flauntParts?.length
                              ? data.flauntParts.join(" , ")
                              : "---"}
                          </td>
                          <td>
                            {" "}
                            {data?.downplayParts?.length
                              ? data.downplayParts.join(" , ")
                              : "---"}
                          </td>
                          <td className="nowrap">{data?.planName}</td>
                          <td className="text-center">
                            <Link
                              to=""
                              onClick={(e) => {
                                e.preventDefault();
                                statusHandler(
                                  data._id,
                                  data?.status.toString()
                                );
                              }}
                            >
                              <SwitchButton status={data?.status.toString()} />
                            </Link>
                          </td>
                          <td>
                            {" "}
                            <div className="icon_wrap">
                              <Link
                                to={`/referral-management/user-list/${data?._id}`}
                                className="button"
                              >
                                View
                              </Link>
                            </div>
                          </td>

                          <td>
                            {" "}
                            <div className="icon_wrap">
                              <Link
                                to={`/user-management/detail/${data?._id}`}
                                className="icon_button"
                              >
                                <FaRegEye />
                              </Link>
                              <Link
                                to=""
                                className="icon_button"
                                onClick={(e) => {
                                  e.preventDefault();
                                  deleteHandler(data?._id);
                                }}
                              >
                                <FaRegTrashAlt />
                              </Link>
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <NotFound
                      cols={12}
                      msg={"User data not found"}
                      onHide={onHide}
                    />
                  )}
                </tbody>
              </table>
            </div>

            {total > limit && (
              <div className="pagination-wrapper">
                <div className="Pagination">
                  <Pagination
                    activePage={activePage}
                    previousLabel={"previous"}
                    nextLabel={"next"}
                    itemsCountPerPage={limit}
                    totalItemsCount={total}
                    pageRangeDisplayed={5}
                    onChange={handlePageChange}
                    hideDisabled={true}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Delete Student Modal */}

      <PopupModal
        show={deleteModal}
        handleClose={() => {
          setSelected({});
          setDeleteModal(false);
        }}
        content="Are you sure you want to delete this User?"
        title="Delete User"
        onShow={changeDeleteHandler}
        buttonLoader={buttonLoaders}
      />

      <PopupModal
        show={statusModal}
        handleClose={closeModal}
        content="Are you sure you want to change status of this User?"
        title="Change Status"
        onShow={changeStatusHandler}
        buttonLoader={buttonLoader}
      />

      <CustomModal
        className={"image_preview_modal"}
        show={imagePreview}
        handleClose={() => setImagePreview(false)}
      >
        <div className="image_preview">
          <img src={imageUrl ? imageUrl : userPlaceholder} alt="" />
        </div>
      </CustomModal>
    </>
  );
};

export default UserManagement;
